module.exports = __webpack_public_path__ + "static/media/placeholder.4af59e4c.png";